import React from "react";

interface LoaderProps {
  message?: string;
}

const Loader: React.FC<LoaderProps> = ({ message }) => {
  return (
    <div className="content-container h-full">
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-300px)]">
        <div className="w-16 h-16 border-4 border-black border-t-transparent rounded-full animate-spin mb-4"></div>
        {message && (
          <p className="text-secondary text-center px-4">{message}</p>
        )}
      </div>
    </div>
  );
};

export default Loader;
